import React, {useEffect} from 'react'
import ClientSuspense from '@components/ClientSuspense'
import Button from '@components/V3/Button'
import Modal from '@components/V3/Modal'
import useModal from '@page-components/CheckoutV3/hooks/useModal'
import {useTranslation} from 'next-i18next'

import useUpselling from './hooks/useUpselling'
import Inner from './Inner'
import UpsellingSkeleton from './Skeleton'

function Upselling() {
  const {isOpen, closeModal, openModal} = useModal('upselling')
  const offers = useUpselling()
  const {t} = useTranslation('checkoutv3', {keyPrefix: 'upselling'})

  useEffect(() => {
    if (offers.length) {
      openModal()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Modal
      forceJustoFont
      hasHeightLimit
      popFromBottom={false}
      isOpen={isOpen}
      onClose={closeModal}
      header={t('title')}
      footer={
        <div className="p-4">
          <Button primary full onClick={() => closeModal()}>
            {t('cancel')}
          </Button>
        </div>
      }>
      <ClientSuspense fallback={<UpsellingSkeleton />}>
        <Inner />
      </ClientSuspense>
    </Modal>
  )
}

export default function UpsellingWrapper() {
  return (
    <ClientSuspense fallback={null}>
      <Upselling />
    </ClientSuspense>
  )
}
